import { createConsumer } from "@rails/actioncable";
import { getCableUrl } from "@/utils/apiUrlUtils";
import { getCookie } from "@/utils/cookieUtils";

// Cable сообщает об изменениях, а актуальные записи и права проверяет REST.
export function createNotificationSubscription({ companyId, onChange, onCountersChange, onCreated }) {
  const token = (getCookie("token") || "").replace(/^Basic /, "");
  const consumer = createConsumer(getCableUrl(token));
  // Reconnect сверяет REST, но не превращает повторную доставку в новое событие.
  const seen = new Set();
  let active = true;

  // Сеть может прервать REST-запрос, не закрыв WebSocket: нового connected не будет.
  const refreshAfterOnline = () => {
    if (!active) return;
    onChange();
    onCountersChange();
  };
  window.addEventListener("online", refreshAfterOnline);

  const subscription = consumer.subscriptions.create(
    { channel: "NotificationChannel", company_id: companyId },
    {
      connected() {
        if (!active) return;
        // В том числе закрывает промежуток между первым GET и подпиской.
        onChange();
      },
      received(data) {
        if (!active || data.company_id !== companyId) return;
        // Прочтение инвалидирует весь личный список, независимо от seen created-id.
        if (data.type === "read") {
          onChange();
          return;
        }
        if (data.type !== "created") return;
        if (!data.notification_id || seen.has(data.notification_id)) return;
        seen.add(data.notification_id);
        if (seen.size > 1000) seen.delete(seen.values().next().value);
        onCreated();
        onChange();
      },
      rejected() {
        // Повторный GET проверяет актуальные права, в том числе их отзыв.
        if (active) onChange();
      },
    }
  );

  const countersSubscription = consumer.subscriptions.create(
    { channel: "NotificationCountersChannel" },
    {
      connected() {
        if (active) onCountersChange();
      },
      received(data) {
        if (active && data.type === "changed") onCountersChange();
      },
      rejected() {
        if (active) onCountersChange();
      },
    }
  );

  return {
    stop() {
      active = false;
      window.removeEventListener("online", refreshAfterOnline);
      subscription.unsubscribe();
      countersSubscription.unsubscribe();
      consumer.disconnect();
    },
  };
}
